import React, { useState } from 'react';

// ---- Button ----
// Props:
//   variant  — 'primary' (gold fill) | 'outline' (ghost) | 'dark' (ink fill)
//   size     — 'sm' | 'md' (default)
//   href     — if set, renders as <a>
//   onClick  — click handler
//   children — button label

const base = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontFamily: 'var(--font-sans)',
  fontWeight: 500,
  letterSpacing: '0.04em',
  borderRadius: 'var(--radius-sm)',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'all 0.2s ease',
  border: 'none',
  outline: 'none',
};

const variants = {
  primary: {
    background: 'var(--gold)',
    color: 'var(--ink)',
  },
  outline: {
    background: 'transparent',
    color: 'var(--text-primary)',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  dark: {
    background: 'var(--ink)',
    color: 'var(--text-primary)',
    border: '1px solid rgba(255,255,255,0.1)',
  },
};

const sizes = {
  sm: { fontSize: '13px', padding: '9px 20px' },
  md: { fontSize: '14px', padding: '13px 30px' },
};

export default function Button({
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  children,
  style = {},
}) {
  const [hovered, setHovered] = useState(false);

  const hoverStyles = {
    primary: { background: 'var(--gold-light)', transform: 'translateY(-1px)' },
    outline: { borderColor: 'var(--gold)', color: 'var(--gold)' },
    dark:    { background: '#1a1d26' },
  };

  const computed = {
    ...base,
    ...variants[variant],
    ...sizes[size],
    ...(hovered ? hoverStyles[variant] : {}),
    ...style,
  };

  if (href) {
    return (
      <a
        href={href}
        style={computed}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      style={computed}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
    </button>
  );
}
